/*
  Кнопка «Скачать» файла загрузки с отказом рядом.

  Аудит 28.10.2026, раздел 5.3: файл, убранный по сроку хранения, скачивался молча - сервер
  отвечал «не найден», а показать это было некому, и нажатие выглядело как зависшая кнопка.
  Отказ показывается здесь же, рядом с нажатым (правило 3 скилла `frontend`).
*/

import { useState } from 'react'

import { api } from '../../api/client.js'
import { Notice } from '../Common.jsx'
import useSingleFlight from '../useSingleFlight.js'

export default function DownloadLink({ fileId, filename }) {
  const [failure, setFailure] = useState(null)
  // Второе нажатие, пока первое скачивание в пути, - второй такой же файл (ревью 30.10.2026).
  const single = useSingleFlight()

  async function save() {
    await single.run(async () => {
      setFailure(null)
      try {
        await api.downloadImportFile(fileId, filename)
      } catch (error) {
        setFailure(error)
      }
    })
  }

  return (
    <>
      <button
        type="button"
        className="link-button"
        // Строк со «Скачать» столько же, сколько файлов: без имени файла читалка экрана
        // назовёт их все одинаково.
        aria-label={`Скачать ${filename}`}
        disabled={single.busy}
        onClick={save}
      >
        Скачать
      </button>
      <Notice error={failure} />
    </>
  )
}
